<template>
  <div>
    <!-- Modal pour gérer les fichiers -->
    <ModalFile
        :selected-image="selectedImage"
        v-show="isModalVisible"
        @close="closeModal"
        @validate="validateModal"
    />
    <div class="form-field form-file" :rel="uniqueId">
      <!-- Label -->
      <div class="form-label" v-if="label">
        <label>{{ label }}</label>
      </div>

      <!-- Zone d'input et Drag & Drop -->
      <div class="form-input">
        <div class="form-input-wrapper" :style="{ maxWidth: maxWidth }">

          <i :class="classLang" v-if="lang"><img :src="'/src/assets/flags/'+lang+'.svg'"></i>

          <!-- Si le fichier est défini, afficher la liste -->
          <div v-if="file" class="listing">
            <!-- Vue d'un élément -->
            <div class="item">
              <div class="image">
                <!-- Aperçu ou icône adaptée -->
                <img v-if="file.mime === 'application/json'" src="/src/assets/images/file-xml.png" />
                <img v-else :src="file.preview" />

                <!-- Boutons d'action -->
                <div class="bt-actions">
                  <button v-if="file.url" class="bt-edit" @click="selectImage()">
                    <icon name="edit-02" />
                  </button>
                  <button v-if="file.url" class="bt-remove" @click="remove()">
                    <icon name="trash-01" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Zone de drag & drop -->
          <div
              v-else
              class="form-file-upload"
              :class="{ 'is-dragging': isDragging }"
              @dragover.prevent="onDragOver"
              @dragleave.prevent="onDragLeave"
              @drop.prevent="onDrop"
              @click="browseFiles"
          >
            <input
                class="input"
                ref="fileInput"
                type="file"
                :id="uniqueId"
                @change="upload"
                style="display: none;"
            />
            <icon name="image-03" />
            <span>Glissez-déposez votre fichier ici, ou <u>cliquez pour parcourir</u></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalFile from "./ModalFile.vue";
import { Api } from "../../Api.js";

export default {
  name: "Upload",
  components: {
    ModalFile,
  },
  props: {
    value: {
      type: [String, Number, null],
      default: null,
    },
    width: {
      type: String,
      default: "33.33%",
    },
    label: {
      type: String,
      default: "",
    },
    lang: {
      default: null
    },
  },
  data() {
    return {
      selectedImage: null,
      isModalVisible: false,
      file: null, // Fichier actuel chargé
      uniqueId: "file-upload-" + Math.random().toString(36).substr(2, 9),
      isDragging: false, // État drag & drop
    };
  },
  computed: {
    // Calculer la largeur maximale d'entrée
    maxWidth() {
      return this.width;
    },
    classLang: function() {
      return this.lang ? "flag lang-" + this.lang : "";
    },
  },
  created() {
    this.get(); // Charger le fichier initial basé sur `value`
  },
  methods: {
    /**
     * Ouvrir le modal pour les fichiers
     */
    openModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    validateModal(image) {
      console.log("image", image)
      this.isModalVisible = false;
      this.file = image;
      this.updateValue(this.file.id);
    },

    /**
     * Action pour sélectionner ou modifier un fichier
     */
    selectImage() {
      this.selectedImage = this.file;
      this.openModal();
    },

    /**
     * Déclencher l'ouverture du champ fichier caché
     */
    browseFiles() {
      this.$refs.fileInput.click();
    },

    /**
     * Gestion des événements de drag & drop
     */
    onDragOver() {
      this.isDragging = true;
    },
    onDragLeave() {
      this.isDragging = false;
    },
    onDrop(event) {
      this.isDragging = false;
      this.handleDrop(event);
    },

    /**
     * Charger un fichier via le champ input
     */
    upload(event) {
      const file = event.target.files[0];
      this.uploadFile(file);
    },

    /**
     * Charger un fichier via drag & drop
     */
    handleDrop(event) {
      const file = event.dataTransfer.files[0];
      this.uploadFile(file);
    },

    /**
     * Logique commune pour uploader un fichier
     */
    uploadFile(file) {
      const data = new FormData();
      data.append("file", file);

      Api()
          .post("media", data)
          .then((response) => {
            this.file = response.data[0];
            this.updateValue(this.file.id);
          });
    },

    /**
     * Supprimer le fichier
     */
    remove() {
      this.file = null;
      this.updateValue(null);
    },

    /**
     * Récupérer un fichier existant via l'API
     */
    get() {
      if (this.value) {
        Api()
            .get("media/" + this.value)
            .then((response) => {
              this.file = response.data;
            });
      } else {
        this.file = null;
      }
    },

    /**
     * Met à jour le parent avec la nouvelle valeur
     */
    updateValue(value) {
      this.$emit("input", value);
    },
  },
  watch: {
    /**
     * Watcher pour charger un nouveau fichier si `value` change
     */
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.get();
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/form/File.vue